export default {
  eyebrow: 'Partnerportaal',
  title: 'Branding',
  description: 'De uitstraling van uw white-label portaal en inlogpagina.',
  page: {
    read_only_notice: 'Alleen-lezen. Klik op Bewerken om een waarde te wijzigen.',
    editing_notice: 'Bewerken — wijzigingen zijn zichtbaar voor uw team en klanten.',
  },
  branding: {
    scope_hint:
      "Van toepassing op uw white-label portaal en inlogpagina — niet op uw restaurantpagina's, die per restaurant worden opgemaakt.",
    upload: 'Logo uploaden',
    logo: {
      label: 'Logo',
      hint: 'Weergegeven op uw white-label oppervlakken.',
    },
    circle_logo: {
      label: 'Favicon / rond logo',
      hint: 'Vierkant logo gebruikt als favicon en avatar. Optioneel — kan worden verwijderd.',
    },
    splash_image: {
      label: 'Inlogafbeelding',
      hint: 'Weergegeven op uw white-label inlogpagina. Aanbevolen: minimaal 1200px breed. Optioneel — kan worden verwijderd.',
    },
    footer_note: 'Meer brandinginstellingen (secundaire kleuren) volgen later.',
  },
  form: {
    primary_color: {
      label: 'Primaire merkkleur',
      hint: 'Thema van uw partnerportaal en inlogpagina.',
    },
    dashboard_subdomain: {
      label: 'Partner-inlogslug',
      hint: 'Slug in kleine letters — identificeert uw merk in de teaminloglink (?partner=…).',
      placeholder: 'partner-naam',
    },
    login_url: {
      label: 'Teaminloglink',
      hint: 'Deel deze link met uw team — de inlogpagina opent met uw branding.',
    },
    file: {
      label: 'Afbeelding',
    },
  },
  login_url_warning: {
    title: 'Teaminloglink wijzigen?',
    description:
      'Uw teaminloglink wordt gewijzigd naar {{url}}. Deel voortaan de nieuwe link — de oude toont uw merk niet meer.',
    description_no_url:
      'Uw teaminloglink wordt gewijzigd. Deel voortaan de nieuwe link — de oude toont uw merk niet meer.',
  },
  login_url_changed: {
    title: 'Teaminloglink gewijzigd',
    description: 'Uw team logt nu in via {{url}}. Sla de nieuwe link op als favoriet en deel deze met uw team.',
  },
  buttons: {
    edit: 'Bewerken',
    cancel: 'Annuleren',
    save: 'Opslaan',
  },
  toasts: {
    load_error: 'Branding kon niet worden geladen.',
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    changes_got_saved: 'Wijzigingen opgeslagen',
    logo_uploaded: 'Logo geüpload',
    logo_upload_failed: 'Logo uploaden mislukt',
    logo_removed: 'Logo verwijderd',
    logo_remove_failed: 'Logo verwijderen mislukt',
    file_too_large: 'Bestand is te groot. Maximale grootte is {{max}} MB.',
    image_too_narrow: 'De inlogafbeelding moet minimaal {{min}}px breed zijn.',
  },
};
